import React, {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Modal_Empleado_Empresa from './modal_empleado_empresa';
import './modal.css';
import firebase from 'firebase';
import {Link} from 'react-router-dom';
import Alert from 'react-s-alert';




const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};




class EmpleadoEmpresa extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			empleados:[],
			isActive:false,
			codigo_empresa:'',
			correo:'',
			dui:'',
			numero_empleado:'',
			pasaporte:'',
			nombre:'',
			apellido:'',
			nombre_titulo:''
			
		}
		
		this.empresaRef=database.ref().child('Clientes').orderByChild('socio').equalTo(this.props.match.params.idempresa);
		this.handleClick=this.handleClick.bind(this);
		this.toggleModalUpdate=this.toggleModalUpdate.bind(this);
		
		
		
	}
	
	
	componentDidMount() {
		this.empresaRef.once('value', this.gotData, this.errData);
	}
	
	gotData = (data) => {
		  let newEmpleados = []
		  const empleadodata = data.val();
		  
		  
		  if(empleadodata!=null){
			  
			
		  const keys = Object.keys(empleadodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
	
		
				newEmpleados.push({
				  key:k,
				  nombre:empleadodata[k].nombre,
				  apellido:empleadodata[k].apellido,				  
				  codigo_empresa:empleadodata[k].codigo_empresa,
				  correo:empleadodata[k].correo,
				  dui:empleadodata[k].dui,
				  numero_empleado:empleadodata[k].numero_empleado,
				  pasaporte:empleadodata[k].pasaporte
				});				
			
			
		  }
		  this.setState({empleados: newEmpleados});  
			  
		  }
		  
		  
		}
		errData = (err) => {
	  console.log(err);
	}
	
	btnEditFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
 
	handleClick = (rowKey) => {
	  
		this.setState({
			
			correo:rowKey.correo,
			dui:rowKey.dui,
			numero_empleado:rowKey.numero_empleado,
			pasaporte:rowKey.pasaporte
			
		});
	  
		this.toggleModalUpdate();
	}
	
	toggleModalUpdate=()=>{
		
		this.setState({
			
			isActive:!this.state.isActive
		})		
	}
 
	
	render(){
		
		
		return(
		
			<div className="EmpleadosEmpresa container">
			
			
					<h1 className="titulo">Empleados {this.props.match.params.nombre}</h1>
					
					<Link to="/empresa"><span className="glyphicon glyphicon-arrow-left"> </span>  Empresas</Link>
					
					<BootstrapTable data={ this.state.empleados }
						 ref='table'			 
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='correo' dataSort={true}>Correo</TableHeaderColumn>
						 <TableHeaderColumn dataField='dui'>Dui</TableHeaderColumn>
						 <TableHeaderColumn dataField='numero_empleado' >Numero de empleado</TableHeaderColumn>
						 <TableHeaderColumn dataField='pasaporte' >Pasaporte</TableHeaderColumn>
					 </BootstrapTable>
				
	
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>

						<form method="POST" action="" onSubmit={this.updateRow}>
			  
								<h3>Modificar Empleado</h3>
								<hr/>
								<div className="form-group">
									<label htmlFor="nombre">Nombre</label>
									<input type="text" name="nombre" className="form-control"
									autoComplete="off" placeholder="Nombre"
									defaultValue={this.state.nombre}
									/>									
								</div>
								<div className="form-group">
									<label htmlFor="apellido">Apellido</label>
									<input type="text" name="apellido" className="form-control"
									autoComplete="off" placeholder="Apellido"
									defaultValue={this.state.apellido}
									/>									
								</div>
								<div className="form-group">
									<label htmlFor="correo">Correo</label>
									<input type="text" name="correo" className="form-control"
									autoComplete="off" placeholder="Correo"
									defaultValue={this.state.correo}
									/>									
								</div>
								<div className="form-group">
									<label htmlFor="dui">Dui</label>
									<input type="text" name="dui" className="form-control"
									autoComplete="off" placeholder="Dui"
									defaultValue={this.state.dui}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="numero_empleado">Numero de empleado</label>
									<input type="text" className="form-control" name="numero_empleado"
									autoComplete="off" placeholder="Numero empleado"
									defaultValue={this.state.numero_empleado}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="pasaporte">Pasaporte</label>
									<input type="text" name="pasaporte" className="form-control"
									autoComplete="off" placeholder="Pasaporte"
									defaultValue={this.state.pasaporte}
									/>
								</div>
					
								<button type="submit" className="btn btn-primary buttons">Guardar</button>
								<button type="button" className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
						</form>
								
					</Modal> 
	
	
			</div>
		
		);
		
		
	}
	
	
}

export default EmpleadoEmpresa;



// WEBPACK FOOTER //
// ./src/Components/Empleados_empresa/Empleados_empresa.jsx